import { EditableTitle, DragHandle } from '../shared/components';
import { Button, Tooltip } from '@bancobarigui/barihaus';
import { EditOutlined, CopyOutlined, DeleteOutlined, RightOutlined, DownOutlined } from '@ant-design/icons';
import { DraggableProvidedDragHandleProps } from 'react-beautiful-dnd';

interface GroupHeaderProps {
  name: string;
  isEditing: boolean;
  editValue: string;
  onEditValueChange: (value: string) => void;
  onSave: () => void;
  onCancel: () => void;
  onEdit: () => void;
  onDuplicate: () => void;
  onRemove: () => void;
  isCollapsed: boolean;
  onToggleCollapse: () => void;
  dragHandleProps: DraggableProvidedDragHandleProps | null;
}

export function GroupHeader({
  name,
  isEditing,
  editValue,
  onEditValueChange,
  onSave,
  onCancel,
  onEdit,
  onDuplicate,
  onRemove,
  isCollapsed,
  onToggleCollapse,
  dragHandleProps,
}: GroupHeaderProps) {
  const handleHeaderClick = (e: React.MouseEvent) => {
    if (isEditing) return;

    const target = e.target as HTMLElement;
    if (target.closest('button')) return;

    onToggleCollapse();
  };

  return (
    <div
      className="flex items-center justify-between cursor-pointer"
      onClick={handleHeaderClick}
    >
      <div className="flex items-center gap-2 flex-1">
        <DragHandle dragHandleProps={dragHandleProps} size="large" />

        {isEditing ? (
          <EditableTitle
            value={editValue}
            onChange={onEditValueChange}
            onSave={onSave}
            onCancel={onCancel}
            size="middle"
            placeholder="Nome do grupo"
          />
        ) : (
          <>
            <h3 className="text-lg font-semibold text-blue-700 dark:text-blue-400 m-0">
              {name}
            </h3>
            <div className="flex items-center" onClick={(e) => e.stopPropagation()}>
              <Tooltip title="Editar nome do grupo">
                <Button
                  type="text"
                  size="small"
                  icon={<EditOutlined />}
                  onClick={onEdit}
                  children={undefined}
                />
              </Tooltip>
              <Tooltip title="Duplicar grupo">
                <Button
                  type="text"
                  size="small"
                  icon={<CopyOutlined />}
                  onClick={onDuplicate}
                  children={undefined}
                />
              </Tooltip>
              <Tooltip title="Remover grupo">
                <Button
                  type="text"
                  size="small"
                  danger
                  icon={<DeleteOutlined />}
                  onClick={onRemove}
                  children={undefined}
                />
              </Tooltip>
            </div>
          </>
        )}
      </div>

      {!isEditing && (
        <Button
          type="text"
          size="small"
          icon={isCollapsed ? <RightOutlined /> : <DownOutlined />}
          onClick={(e) => {
            e.stopPropagation();
            onToggleCollapse();
          }}
          className="p-0 h-auto"
          children={undefined}
        />
      )}
    </div>
  );
}
